import {useState} from 'react'

export function useMultiStepForm(titles: string[]) {
  const [step, setStep] = useState(0)
  const maxSteps = titles.length

  const nextStep = () => {
    setStep(prev => (prev < maxSteps - 1 ? prev + 1 : prev))
  }

  const prevStep = () => {
    setStep(prev => (prev > 0 ? prev - 1 : prev))
  }

  return {
    nextStep,
    prevStep,
    title: titles[step] ?? '',
    subtitle: `Step ${step + 1} of ${maxSteps}`,
    step,
  }
}
